import { render, staticRenderFns } from "./form.vue?vue&type=template&id=19b19eb5&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=19b19eb5&scoped=true&lang=less&"
import style1 from "@/styles/workflow/zr-workflow-ui.css?vue&type=style&index=1&lang=css&"
import style2 from "./form.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b19eb5",
  null
  
)

export default component.exports